<template>
  <div class="layout-footer">
    <span class="footer-text" style="margin-right: 5px"
      >&copy; {{ currentYear }} Putra Muda Mandiri. MPOS Cashier
      {{ appVersion }}</span
    >
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    appVersion() {
      return process.env.VUE_APP_VERSION || '2.0.0'
    }
  }
}
</script>

<style scoped></style>
